import { Component } from '@angular/core';
import { BuyerSeller } from '../../../../core/models/mysec/buy-sell-content';
import { HostListener } from '@angular/core';

@Component({
    selector: 'app-buy-sell-tutorial',
    templateUrl: './buy-sell-tutorial.component.html',
    styleUrls: ['./buy-sell-tutorial.component.scss'],
    standalone: false
})
export class BuySellTutorialComponent {
  tutorialContent: string;
  // showButtonScrollHeight: number = 900;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    const element = document.getElementsByClassName('buy-sell-parent')[0];

    console.log(element?.getBoundingClientRect().top);

    if (element?.getBoundingClientRect().top <= 260) {
      // Add a class to trigger the animation
      element?.classList.add('active');
    }
  }

  setContent(role) {
    this.tutorialContent = role;
  }

  resetContent() {
    this.tutorialContent = null;
  }

  buyerSellerTutorial: BuyerSeller = {
    'buyer': {
      'title':
        'howItWorksPage.tutorialBuyerTitle',
      'tabs': [
        {
          'title': 'howItWorksPage.tutorialBuyTabTitle1',
          'steps': [
            {
              'description':
                'howItWorksPage.tutorialBuyStep1',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 15,
                      'price': 12.0,
                      'isHighlighted': 'gray',
                      'isBold': true,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 10,
                      'price': 10.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 12,
                      'price': 11.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 20,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': null,
                  'quantity': null,
                  'investmentAmount': null,
                  'shareAveragePrice': null,
                  'isHighlighted': null,
                },
              },
            },
            {
              'description':
                'howItWorksPage.tutorialBuyStep2',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 15,
                      'price': 12.0,
                      'isHighlighted': 'gray',
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 10,
                      'price': 10.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 12,
                      'price': 11.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 20,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': null,
                  'quantity': null,
                  'investmentAmount': null,
                  'shareAveragePrice': null,
                  'isHighlighted': null,
                },
              },
            },
            {
              'description': 'howItWorksPage.tutorialBuyStep3',
              'content': {
                'orderBook': {
                  'buyOrders': [],
                  'sellOrders': [
                    {
                      'volume': 7,
                      'price': 11.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 20,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 15,
                  'investmentAmount': 'RM155.00',
                  'shareAveragePrice': 'RM10.20',
                  'isHighlighted': 'green',
                },
              },
            },
          ],
        },
        {
          'title': 'howItWorksPage.tutorialBuyTabTitle2',
          'steps': [
            {
              'description':
                'howItWorksPage.tutorialBuyPreMarketStep1',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': true,
                    },
                    {
                      'volume': 5,
                      'price': 14.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 15,
                      'price': 11.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 15,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 50,
                      'price': 12.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': null,
                  'quantity': null,
                  'investmentAmount': null,
                  'shareAveragePrice': null,
                  'isHighlighted': null,
                },
              },
            },
            {
              'description':
                'howItWorksPage.tutorialBuyPreMarketStep2',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': false,
                    },
                    {
                      'volume': 5,
                      'price': 14.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 15,
                      'price': 11.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 15,
                      'price': 11.5,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 50,
                      'price': 12.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': null,
                  'quantity': null,
                  'investmentAmount': null,
                  'shareAveragePrice': null,
                  'isHighlighted': null,
                },
              },
            },
            {
              'description': 'howItWorksPage.tutorialBuyPreMarketStep3',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 5,
                      'price': 14.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 10,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 50,
                      'price': 12.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 20,
                  'investmentAmount': 'RM222.50',
                  'shareAveragePrice': 'RM11.13',
                  'isHighlighted': 'green',
                },
              },
            },
          ],
        },
        {
          'title': 'howItWorksPage.tutorialBuyTabTitle3',
          'steps': [
            {
              'description':
                'howItWorksPage.tutorialBuyBlankStep1',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': true,
                    },
                    {
                      'volume': 5,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 13.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [],
                },
                'portfolio': {
                  'business': null,
                  'quantity': null,
                  'investmentAmount': null,
                  'shareAveragePrice': null,
                  'isHighlighted': null,
                },
              },
            },
            {
              'description':
                'howItWorksPage.tutorialBuyBlankStep2',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': false,
                    },
                    {
                      'volume': 5,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 13.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 15,
                      'price': 14.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                  ],
                },
                'portfolio': {
                  'business': null,
                  'quantity': null,
                  'investmentAmount': null,
                  'shareAveragePrice': null,
                  'isHighlighted': null,
                },
              },
            },
            {
              'description': 'howItWorksPage.tutorialBuyBlankStep3',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 5,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': false,
                    },
                    {
                      'volume': 5,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 13.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 15,
                  'investmentAmount': 'RM225.00',
                  'shareAveragePrice': 'RM15.00',
                  'isHighlighted': 'green',
                },
              },
            },
          ],
        },
      ],
    },
    'seller': {
      'title':
        'howItWorksPage.tutorialSellerTitle',
      'tabs': [
        {
          'title': 'howItWorksPage.tutorialSellTabTitle1',
          'steps': [
            {
              'description':
                'howItWorksPage.tutorialSellStep1',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 12,
                      'price': 13.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 12.8,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 20,
                      'price': 11.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 20,
                      'price': 12.0,
                      'isHighlighted': 'gray',
                      'isBold': true,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 50,
                  'investmentAmount': 'RM600.00',
                  'shareAveragePrice': 'RM12.00',
                  'isHighlighted': 'yellow',
                },
              },
            },
            {
              'description':
                'howItWorksPage.tutorialSellStep2',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 12,
                      'price': 13.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 10,
                      'price': 12.8,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 20,
                      'price': 11.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 20,
                      'price': 12.0,
                      'isHighlighted': 'gray',
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 50,
                  'investmentAmount': 'RM600.00',
                  'shareAveragePrice': 'RM12.00',
                  'isHighlighted': null,
                },
              },
            },
            {
              'description': 'howItWorksPage.tutorialSellStep3',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 2,
                      'price': 12.8,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 20,
                      'price': 11.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 30,
                  'investmentAmount': 'RM341.60',
                  'shareAveragePrice': 'RM11.39',
                  'isHighlighted': 'green',
                },
              },
            },
          ],
        },
        {
          'title': 'howItWorksPage.tutorialSellTabTitle2',
          'steps': [
            {
              'description':
                'howItWorksPage.tutorialSellPreMarketStep1',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 14.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 30,
                      'price': 11.0,
                      'isHighlighted': 'gray',
                      'isBold': true,
                    },
                    {
                      'volume': 15,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 50,
                      'price': 12.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 30,
                  'investmentAmount': 'RM330.00',
                  'shareAveragePrice': 'RM11.00',
                  'isHighlighted': 'yellow',
                },
              },
            },
            {
              'description':
                'howItWorksPage.tutorialSellPreMarketStep2',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 10,
                      'price': 14.5,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                    {
                      'volume': 10,
                      'price': 14.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 30,
                      'price': 11.0,
                      'isHighlighted': 'gray',
                      'isBold': false,
                    },
                    {
                      'volume': 15,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 50,
                      'price': 12.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 30,
                  'investmentAmount': 'RM330.00',
                  'shareAveragePrice': 'RM11.00',
                  'isHighlighted': null,
                },
              },
            },
            {
              'description': 'howItWorksPage.tutorialSellPreMarketStep3',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 10,
                      'price': 14.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 15,
                      'price': 11.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 50,
                      'price': 12.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': null,
                  'quantity': null,
                  'investmentAmount': null,
                  'shareAveragePrice': null,
                  'isHighlighted': 'green',
                },
              },
            },
          ],
        },
        {
          'title': 'howItWorksPage.tutorialSellTabTitle3',
          'steps': [
            {
              'description':
                'howItWorksPage.tutorialSellBlankStep1',
              'content': {
                'orderBook': {
                  'buyOrders': [],
                  'sellOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': true,
                    },
                    {
                      'volume': 5,
                      'price': 15.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 16.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 20,
                  'investmentAmount': 'RM300.00',
                  'shareAveragePrice': 'RM15.00',
                  'isHighlighted': 'yellow',
                },
              },
            },
            {
              'description':
                'howItWorksPage.tutorialSellBlankStep2',
              'content': {
                'orderBook': {
                  'buyOrders': [
                    {
                      'volume': 10,
                      'price': 15.0,
                      'isHighlighted': 'yellow',
                      'isBold': true,
                    },
                  ],
                  'sellOrders': [
                    {
                      'volume': 20,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': false,
                    },
                    {
                      'volume': 5,
                      'price': 15.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 16.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 20,
                  'investmentAmount': 'RM300.00',
                  'shareAveragePrice': 'RM15.00',
                  'isHighlighted': null,
                },
              },
            },
            {
              'description': 'howItWorksPage.tutorialSellBlankStep3',
              'content': {
                'orderBook': {
                  'buyOrders': [],
                  'sellOrders': [
                    {
                      'volume': 10,
                      'price': 15.0,
                      'isHighlighted': 'gray',
                      'isBold': true,
                    },
                    {
                      'volume': 5,
                      'price': 15.5,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                    {
                      'volume': 10,
                      'price': 16.0,
                      'isHighlighted': null,
                      'isBold': false,
                    },
                  ],
                },
                'portfolio': {
                  'business': 'MyECO Sdn Bhd',
                  'quantity': 10,
                  'investmentAmount': 'RM150.00',
                  'shareAveragePrice': 'RM15.00',
                  'isHighlighted': 'green',
                },
              },
            },
          ],
        },
      ],
    },
  };
}
